import { render, staticRenderFns } from "./SpuModify.vue?vue&type=template&id=478ad118"
import script from "./SpuModify.vue?vue&type=script&lang=ts"
export * from "./SpuModify.vue?vue&type=script&lang=ts"
import style0 from "./SpuModify.vue?vue&type=style&index=0&id=478ad118&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports